'use client';
import { useState } from 'react';
import { useRouter } from 'next/navigation';
import Image from 'next/image';

export default function BodocardForm() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    certificate: '',
  });
  const [formErrors, setFormErrors] = useState({
    name: '',
    phone: '',
    certificate: '',
    general: '',
  });
  const [loading, setLoading] = useState(false);
  const router = useRouter();

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (formErrors[name as keyof typeof formErrors]) {
      setFormErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const errors = { name: '', phone: '', certificate: '', general: '' };
    if (!formData.name) errors.name = "Ім'я є обов'язковим";
    if (!formData.phone) {
      errors.phone = 'Телефон є обов’язковим';
    } else if (!formData.phone.match(/^\+?[0-9]{10,14}$/)) {
      errors.phone = 'Невірний формат номера телефону';
    }
    if (!formData.certificate) errors.certificate = 'Номер сертифікату є обов’язковим';
    if (Object.values(errors).some(error => error)) {
      setFormErrors(errors);
      return;
    }
    setLoading(true);
    try {
      const utmTags = JSON.parse(localStorage.getItem('utmTags') || '{}') || {};
      const dataToSend = {
        ...formData,
        ...utmTags,
      };
      const axios = (await import('axios')).default;
      await axios.post('https://ap-server-8qi1.onrender.com/leads/bodocard', dataToSend, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      router.push('/thankyou');
    } catch (error) {
      setFormErrors(prev => ({ ...prev, general: 'Форма не відправлена. Спробуйте ще раз.' }));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full min-h-screen flex flex-col items-center justify-center bg-black text-white relative">
      <div className="absolute top-8 flex justify-center w-full z-10">
        <Image
          src="/assets/icon/LogoRevers.svg"
          alt="AP Education Logo"
          width={191}
          height={38}
          className="h-10 w-auto"
        />
      </div>
      <div className="absolute inset-0 -z-0 pointer-events-none">
        <div className="absolute top-0 left-0 w-80 h-80 bg-gradient-to-br from-[#0F645B] to-[#09C6CC] rounded-full opacity-70 blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-80 h-80 bg-gradient-to-br from-[#0F645B] to-[#09C6CC] rounded-full opacity-70 blur-3xl"></div>
      </div>
      <div className="max-w-md w-full bg-gray-900 p-6 rounded-lg shadow-md mt-10 z-10">
        <h2 className="text-xl text-center font-bold mb-4">
          Щоб використати сертифікат від Bodocard заповніть форму
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            name="name"
            placeholder="Ваше ім'я"
            value={formData.name}
            onChange={handleInputChange}
            className={`block w-full px-4 py-2 rounded bg-gray-800 text-white ${formErrors.name ? 'border-red-500' : ''}`}
          />
          {formErrors.name && <p className="text-red-500 text-sm">{formErrors.name}</p>}

          <input
            type="text"
            name="phone"
            placeholder="Номер телефону"
            value={formData.phone}
            onChange={handleInputChange}
            className={`block w-full px-4 py-2 rounded bg-gray-800 text-white ${formErrors.phone ? 'border-red-500' : ''}`}
          />
          {formErrors.phone && <p className="text-red-500 text-sm">{formErrors.phone}</p>}

          <input
            type="text"
            name="certificate"
            placeholder="Номер сертифікату"
            value={formData.certificate}
            onChange={handleInputChange}
            className={`block w-full px-4 py-2 rounded bg-gray-800 text-white ${formErrors.certificate ? 'border-red-500' : ''}`}
          />
          {formErrors.certificate && (
            <p className="text-red-500 text-sm">{formErrors.certificate}</p>
          )}

          {formErrors.general && (
            <p className="text-red-500 text-sm text-center">{formErrors.general}</p>
          )}

          <button
            type="submit"
            disabled={loading}
            className={`w-full bg-green-500 text-white py-2 rounded hover:bg-green-600 ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
          >
            {loading ? 'Зачекайте...' : 'Відправити'}
          </button>
        </form>
      </div>
    </div>
  );
}
